// extracted by mini-css-extract-plugin
module.exports =  {"realtorsBlock":"realtorsBlock___jc9T8","realtor":"realtor___AJ0Hn","realtorImage":"realtorImage___RuRyH","staff":"staff___SFJDh"};